import * as React from "react";

export function LargeButton({link, text, newTab}) {
  return (
    <a
      href={link}
      {...(newTab ? { target: "_blank", rel: "noreferrer" } : {})}
      className="inline-block rounded-md bg-brand-lime px-8 py-5 text-xl text-brand-dark shadow-xs hover:bg-brand-lime/80 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-lime"
    >
      {text}
    </a>
  );
}

export function SecondaryButton({ link, text }) {
  return (
    <a
      href={link}
      className="inline-block rounded-md border-2 border-brand-lime px-8 py-5 text-xl text-brand-lime hover:bg-brand-lime hover:text-brand-dark transition"
    >
      {text}
    </a>
  );
}

export function TicketButton() {
  return <LargeButton link="/tickets" text="Buy Tickets" />
}
